module.exports = __webpack_public_path__ + "static/media/search-icon.769ea419.svg";